<template>
  <AccountDeletionRequestList />
</template>

<script>
import AccountDeletionRequestList from '@/components/AccountDeletionRequest/AccountDeletionRequestList';

export default {
  name: 'AccountDeletionRequestView',
  components: { AccountDeletionRequestList },
};
</script>
